// extracted by mini-css-extract-plugin
export default {"banner":"zWkdD1lfmbMzMwQ5XRzr","link":"DcuE4ZREr4yljE5cx8gY","arrowIcon":"MMfMPN7anVBf_6iGiLoQ"};